export const Paths = {
	ElproPredict: {
		Overview: '/elproPREDICT',
		Configure: '/elproPREDICT/configure',
	},
	Sensor: {
		Analysis: '/sensorAnalysis',
	},
	Settings: {
		PredictiveAnalytics: '/settings/PredictiveAnalytics',
	},
};
